//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { QInput, date } from "quasar";
import { staticBadgeStyle } from "@/assets/js/appFunc";
import AQDatetime from "@/components/Generics/AQDatetime/AQDatetime.vue";
import AQ_INPUT_PROPS from "./AQInput.const";

export default {
    name: "AQInput",
    components: {
        QInput,
        AQDatetime
    },
    mixins: [QInput],
    props: {
        ...AQ_INPUT_PROPS,
        dateProps: { type: Object, default: () => ({}) },
        dateModelMask: { type: String, default: null } // without modelMask the emitted value will have the legacy Aurachain format:"YYYY-MM-DDTHH:mm:ss.SSSZ"
        /// ///////////////////////////////////////// for custom formats check quasar date uitility docs(!!if you switch formats, old data is unreadable!!)
    },
    data() {
        return {
            localValue: "",
            isPwd: true,
            inputType: null,
            isFocused: false,
            localLabel: "",
            datePickerOpen: false,
            format: {
                time: "HH:mm",
                date: "MM-DD-YYYY",
                datetime: "MM-DD-YYYY HH:mm"
            }
        };
    },
    computed: {
        setAutogrow() {
            return this.type === "textarea" || this.autogrow;
        },
        datepicker() {
            return this.type === "date" || this.type === "datetime" || this.type === "time";
        },
        displayedValue() {
            if (this.datepicker) {
                return this.convertToDisplayedTime(this.value);
            }
            return this.value;
        }
    },
    watch: {
        type: {
            handler(val) {
                this.inputType = val;
            },
            immediate: true
        }
    },
    mounted() {
        if (this.hasAppend) {
            this.switchInputContent();
            this.$forceUpdate();
        }
    },
    methods: {
        staticBadgeStyle,
        showPass() {
            this.isPwd = !this.isPwd;
            this.inputType = this.isPwd ? "password" : "text";
        },
        setEmitedValue(value) {
            let inputValue = value;
            if (value === null && this.clearable) {
                inputValue = "";
                if (this.clearValue && this.clearValue === "null") {
                    inputValue = null;
                }
            }
            return inputValue;
        },
        convertToDisplayedTime(datetime) {
            if (!datetime) {
                return "";
            }
            let extracted;
            if (this.type === "time" && !datetime.includes("T")) {
                const today = date.formatDate(new Date(), "YYYY-MM-DD");
                const val = `${today}T${datetime}`;
                extracted = date.extractDate(val, "YYYY-MM-DDTHH:mm:ssZ");
            } else {
                extracted = date.extractDate(datetime, this.dateModelMask || "YYYY-MM-DDTHH:mm:ss.SSSZ");
            }
            const formated = date.formatDate(extracted, this.mask || this.format[this.type]);
            return formated;
        },
        convertToEmittedTime(datetime) {
            if (!datetime) {
                return "";
            }
            const extracted = date.extractDate(datetime, "x");
            const emitDate = date.formatDate(extracted, this.dateModelMask || "YYYY-MM-DDTHH:mm:ss.SSSZ");
            return emitDate;
        },
        search() {
            this.$emit("search", true);
        },
        setValue(newVal) {
            this.localValue = this.setEmitedValue(newVal);
            if (this.datepicker) {
                this.$emit("input", this.convertToEmittedTime(newVal));
            } else {
                this.$emit("input", this.localValue);
            }
        },
        focusInEvt(ev) {
            this.isFocused = true;
            this.$emit("focusin", ev);
        },
        focusEvt(ev) {
            this.isFocused = true;
            this.$emit("focus", ev);
        },
        clickEvent(ev) {
            this.$emit("click", ev);
        },
        blurEvt(ev) {
            this.isFocused = false;
            this.$emit("blur", ev);
            this.$emit("blurValue", this.localValue);
        },
        focusOutEvt(ev) {
            this.$emit("focusout", ev);
        },
        clearEvt(ev) {
            this.$emit("clear", ev);
        },
        changeEvt(newVal) {
            this.$emit("change", newVal);
        },
        keyDown(ev) {
            this.$emit("keyDown", ev);
        },
        keyUp(ev) {
            this.$emit("keyUp", ev);
        },
        keyEnter(ev) {
            this.$emit("keyUpEnter", ev);
        },
        closeTimeModal() {
            this.$emit("closeTimeModal");
        },
        switchInputContent() {
            const { AQInput } = this.$refs;
            const __getSwitchedContent = function (h) {
                const node = [];
                if (this.$scopedSlots.prepend !== undefined) {
                    node.push(
                        h("div", {
                            staticClass: "q-field__prepend q-field__marginal row no-wrap items-center",
                            key: "prepend",
                            on: this.slotsEvents
                        }, this.$scopedSlots.prepend())
                    );
                }

                node.push(
                    h("div", {
                        staticClass: "q-field__control-container col relative-position row no-wrap q-anchor--skip"
                    }, this.__getControlContainer(h))
                );
                if (this.clearable === true && this.hasValue === true && this.editable === true) {
                    node.push(
                        this.__getInnerAppendNode(h, "inner-clearable-append", [
                            h("q-icon", {
                                staticClass: "q-field__focusable-action",
                                props: { tag: "button", name: this.clearIcon || this.$q.iconSet.field.clear },
                                attrs: { tabindex: 0, type: "button" },
                                on: this.clearableEvents
                            })
                        ])
                    );
                }
                if (this.$scopedSlots.append !== undefined) {
                    node.push(
                        h("div", {
                            staticClass: "q-field__append q-field__marginal row no-wrap items-center",
                            key: "append",
                            on: this.slotsEvents
                        }, this.$scopedSlots.append())
                    );
                }
                if (this.hasError === true && this.noErrorIcon === false) {
                    node.push(
                        this.__getInnerAppendNode(h, "error", [
                            h("q-icon", { props: { name: this.$q.iconSet.field.error, color: "negative" } })
                        ])
                    );
                }

                if (this.loading === true || this.innerLoading === true) {
                    node.push(
                        this.__getInnerAppendNode(h, "inner-loading-append",
                            this.$scopedSlots.loading !== undefined
                                ? this.$scopedSlots.loading()
                                : [h("q-spinner", { props: { color: this.color } })])
                    );
                }

                if (this.__getInnerAppend !== undefined) {
                    this.__getInnerAppendNode(h, "inner-append", this.__getInnerAppend(h));
                }
                if (this.__getControlChild !== undefined) {
                    node.push(this.__getControlChild(h));
                }

                return node;
            };
            AQInput.__getContent = __getSwitchedContent.bind(AQInput);
        }
    }
};
